<template>
  <Checkbox
    v-model="checked"
    class="p-switch p-fill"
    :class="size"
    @change="$emit('change', $event)"
  />
</template>

<script>
import * as Checkbox from "pretty-checkbox-vue/check";

export default {
  name: "UiCheckbox",
  components: { Checkbox },
  props: {
    size: {
      type: String,
      default: "",
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      checked: this.value,
    };
  },
};
</script>

<style>
div.pretty.p-switch .state:before {
  @apply shadow border rounded-full bg-white border-grey-lighter;
  height: calc(1em + 4px);
}

div.pretty.p-switch,
div.pretty.p-switch .state label {
  @apply text-base;
}

div.pretty.p-switch.lg,
div.pretty.p-switch.lg .state label {
  @apply text-lg;
}

div.pretty.p-switch .state label:after {
  left: 2px;
  top: -1px;
}

div.pretty.p-switch.p-fill input:checked ~ .state label:after {
  @apply border;
  border-color: #449487;
}

div.pretty.p-switch.p-fill input:checked ~ .state:before {
  @apply bg-success !important;
  border-color: #1da08a !important;
}
</style>
